import React, { useMemo } from 'react';
import { Paper, Typography, Box, useTheme } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';

const CustomMessage: React.FC = () => {
    const { user } = useAuth();
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const getGreeting = useMemo(() => {
        const hour = new Date().getHours();
        if (hour < 12) return t('customMessage.goodMorning');
        if (hour < 18) return t('customMessage.goodAfternoon');
        return t('customMessage.goodEvening');
    }, [t]);

    const getFormattedDate = useMemo(() => {
        const options: Intl.DateTimeFormatOptions = {
            weekday: 'long',
            month: 'long',
            day: 'numeric'
        };
        return new Date().toLocaleDateString(i18n.language, options);
    }, [i18n.language]);

    return (
        <Paper
            elevation={0}
            sx={{
                padding: '5px',
                position: 'relative',
                overflow: 'hidden',
                backgroundColor: 'transparent',
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                <Typography className='text-sm'
                    sx={{
                        fontFamily: 'System Font',
                        fontWeight: 400,
                        fontSize: '14px',
                        color: theme.palette.background.dark,
                        lineHeight: '1.2 !important',
                        textAlign: 'center',
                        margin: '65px 0px 40px 0px',

                    }}
                >
                    {t('customMessage.greeting', { greeting: getGreeting, name: user?.firstname, date: getFormattedDate })}
                </Typography>
                <Typography
                    sx={{
                        fontWeight: 100,
                        fontSize: '22px',
                        margin: '20px 0px 40px 0px',
                        color: theme.palette.background.dark,
                        lineHeight: '1.2 !important',
                        textAlign: 'center',
                        fontStyle: 'italic',
                    }}
                >
                    {user?.dailyReading?.quote}
                </Typography>
            </Box>
        </Paper >
    );
};

export default CustomMessage;
